import { GTMScript, GTMScriptProps } from '../tracking.model';

const getScript = (googleAnalyticsId: string) => `(function(w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', '${googleAnalyticsId}');`;

/**
 * Note: Attributes type="text/plain" and data-usercentrics="Google Tag Manager" are added
 * to the Google Tag Manager script, in order for the script to only be
 * activated once consent for Google Tag Manager is given.
 * @param gtm
 * @returns Google Tag Manager script
 *
 * Google Tag Manager is a tag management system that acts as common tool for running all different tracking tags s
 * uch as Google Ads, Google Analytics, Facebook Pixel, Linkedln tags through
 * the single central interface of Google Tag Manager.
 */

const gtmObject = (gtm: GTMScriptProps): GTMScript => {
  return {
    innerHTML: getScript(gtm.analyticsId),
    type: 'text/plain',
    'data-usercentrics': gtm['data-test-id'] ?? 'Google Tag Manager',
    defer: gtm.defer ?? true,
    async: gtm.async ?? true,
    id: gtm.id ?? 'gtm-cmp',
  };
};
export default gtmObject;
